import { useWeb3 } from '../contexts/Web3Context';
import { shortHash } from '../lib/chainExplorer';

export default function WalletButton() {
  const { account, isConnected, isConnecting, isWrongNetwork, connect, disconnect, switchNetwork, error } = useWeb3();

  if (!window.ethereum) {
    return (
      <a
        href="https://metamask.io/download/"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-1.5 rounded-lg border border-orange-200 bg-orange-50 px-3 py-1.5 text-xs font-bold text-orange-700 hover:bg-orange-100"
      >
        <span className="material-symbols-outlined" style={{ fontSize: 14 }}>download</span>
        Install MetaMask
      </a>
    );
  }

  if (!isConnected) {
    return (
      <div className="flex flex-col items-end gap-1">
        <button
          onClick={connect}
          disabled={isConnecting}
          className="flex items-center gap-1.5 rounded-lg bg-primary px-3 py-1.5 text-xs font-bold text-white hover:bg-primary/90 disabled:opacity-60"
        >
          {isConnecting ? (
            <>
              <span className="animate-spin rounded-full h-3 w-3 border-b-2 border-white" />
              Connecting…
            </>
          ) : (
            <>
              <span className="material-symbols-outlined" style={{ fontSize: 14 }}>account_balance_wallet</span>
              Connect Wallet
            </>
          )}
        </button>
        {error && <p className="text-[10px] text-red-600 max-w-[180px] text-right">{error}</p>}
      </div>
    );
  }

  if (isWrongNetwork) {
    return (
      <button
        onClick={switchNetwork}
        className="flex items-center gap-1.5 rounded-lg border border-amber-300 bg-amber-50 px-3 py-1.5 text-xs font-bold text-amber-700 hover:bg-amber-100"
      >
        <span className="material-symbols-outlined" style={{ fontSize: 14 }}>warning</span>
        Wrong Network — Switch
      </button>
    );
  }

  return (
    <div className="group relative">
      <button className="flex items-center gap-2 rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-xs font-bold text-emerald-700 hover:bg-emerald-100">
        <span className="size-2 rounded-full bg-emerald-500" />
        {shortHash(account, 6, 4)}
      </button>
      {/* Disconnect menu on hover. The gap between the button and the menu is
          padding on this wrapper rather than a margin on the menu, so the cursor
          never leaves the hover target on its way down — a margin here closes the
          menu before it can be clicked. */}
      <div className="absolute right-0 top-full z-10 hidden w-max pt-1 group-hover:block">
        <button
          onClick={disconnect}
          className="block w-full rounded-lg border border-border-subtle bg-white px-3 py-1.5 text-xs font-bold text-red-600 shadow-md hover:bg-red-50"
        >
          Disconnect
        </button>
      </div>
    </div>
  );
}
